module.exports = __webpack_public_path__ + "static/favicon-ac7402ce9e4e97506b2cb0a3f39e25d9.ico";